<form
	class="bg-white rounded-lg pt-[24px] py-[36px] px-[48px] max-mobile:py-[7px] max-mobile:px-[12px]"
>
	<div (click)="closeDialog()">
		<img
			class="ml-[100%] cursor-pointer"
			src="assets/images/close-square.svg"
			alt=""
		/>
	</div>
	<div class="text-center">
		<h1
			class="m-0 text-dark-grey ltr:font-DIN-bold font-bold rtl:font-semi-bold"
		>
			{{ data.title | translate }}
		</h1>
	</div>
	<div *ngIf="data.hasImg">
		<div
			*ngIf="
				(data.type == 'add' || data?.editBrand) &&
				!formEditedData?.parentId &&
				getController('image')?.value == null
			"
			(click)="uploadImage()"
			class="my-[14px] text-center"
		>
			<img
				class="cursor-pointer mx-auto  {{
					getController('image')?.value ? 'my-3 w-[204px]  ' : ''
				}} "
				[src]="
					getController('image')?.value
						? imagePath + getController('image')?.value
						: 'assets/images/gallery-add.svg'
				"
				alt=""
			/>
			<p
				class="cursor-pointer"
				*ngIf="!getController('image')?.value"
				class="text-[#007AFF] mt-2"
			>
				{{ 'ACTIONS.UPLOAD_IMG' | translate }}
				<span *ngIf="!getController('image')?.value" class="text-gradient mx-1">
					*
				</span>
			</p>
		</div>
		<img
			class="w-[150px] h-[150px]"
			*ngIf="getController('image')?.value && data.type == 'add'"
			[src]="imagePath + getController('image')?.value"
			alt=""
		/>
		<div
			*ngIf="
				(data.type == 'edit' || data.editBrand) &&
				getController('image')?.value != null
			"
		>
			<div class="relative  {{ data?.editBrand ? 'w-[204px]' : 'w-[56px]' }}">
				<img
					*ngIf="getController('image')?.value"
					(click)="getController('image')?.setValue(null)"
					class="absolute top-0 right-0 w-[20px] cursor-pointer"
					src="assets/images/icon-regular-close.svg"
					alt=""
				/>

				<img
					(click)="uploadImage()"
					class="cursor-pointer  {{
						data?.editBrand
							? 'w-[204px] '
							: 'rounded-full my-3 w-[56px] h-[56px]'
					}}"
					[src]="
						getController('image')?.value ||
						getController('image')?.value == null
							? imagePath + getController('image')?.value
							: imagePath + formEditedData.imageUrl
					"
					alt=""
				/>
			</div>
		</div>
	</div>
	<div class="mt-5" [formGroup]="formData">
		<mat-form-field class="w-full" appearance="outline">
			<mat-label>
				{{ data.label | translate }}
			</mat-label>
			<input
				matInput
				autofocus="false"
				class="text-dark-grey"
				formControlName="formControl"
				(change)="checkNameExist('formControl')"
				type="text"
			/>

			<mat-error>
				<validation-message
					[controller]="getController('formControl')"
					controller_name="{{ data.label }}"
					pattern_Message="VALIDATION.NAME"
				>
				</validation-message>
			</mat-error>
		</mat-form-field>
		<span
			*ngIf="enNameExist && getController('formControl').value"
			class="whitespace-nowrap text-font-12 block text-red-error mb-[5px] mt-[-5px] px-[10px]"
			>{{ 'VALIDATION.NAME_IN_USE' | translate }}</span
		>
		<mat-form-field class="w-full" appearance="outline">
			<mat-label>
				{{ data.label2 | translate }}
			</mat-label>
			<input
				matInput
				autofocus="false"
				class="text-dark-grey"
				formControlName="formControl2"
				(change)="checkNameExist('formControl2')"
				type="text"
			/>

			<mat-error>
				<validation-message
					[controller]="getController('formControl2')"
					controller_name="{{ data.label2 }}"
					pattern_Message="VALIDATION.NAME"
				>
				</validation-message>
			</mat-error>
		</mat-form-field>

		<span
			*ngIf="arNameExist && getController('formControl2').value"
			class="whitespace-nowrap text-font-12 pt-[5px] block text-red-error mb-[5px] mt-[-5px] px-[10px]"
			>{{ 'VALIDATION.NAME_IN_USE' | translate }}</span
		>
	</div>

	<div class="text-center">
		<button
			[disabled]="formData.invalid || enNameExist || arNameExist"
			[ngClass]="'bg-gradient text-white'"
			(click)="confirm()"
			class="w-full mt-3"
			mat-button
		>
			{{ data.confirmBtn | translate }}
		</button>

		<button
			[ngClass]="'text-medium-gray bg-transparent'"
			*ngIf="data.cancelBtn"
			(click)="closeDialog()"
			class="w-full mt-3 border-[1px] border-solid border-[#D9DBE9]"
			mat-button
		>
			{{ data.cancelBtn | translate }}
		</button>
	</div>
</form>
